import React, { useEffect, Fragment, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
// === ALL HEAD INJECTIONS IN A SINGLE FRAGMENT ===
const frag = document.createDocumentFragment();
// Preconnect
const pc = document.createElement('link');
pc.rel = 'preconnect';
pc.href = 'https://cdn.magicpatterns.com';
frag.appendChild(pc);
// Preload hero image
const pl = document.createElement('link');
pl.rel = 'preload';
pl.as = 'image';
pl.setAttribute('imagesizes', '(max-width: 768px) 100vw, 768px');
pl.href = 'https://cdn.magicpatterns.com/uploads/87dYyEWwxvxDSawQQfbd23/WhatsApp_Image_2026-03-23_at_23.51.54.jpg';
frag.appendChild(pl);
// Non-blocking Google Fonts
const fl = document.createElement('link');
fl.rel = 'stylesheet';
fl.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;700;800&display=swap';
fl.media = 'print';
fl.onload = function () {
  fl.media = 'all';
};
frag.appendChild(fl);
// SEO meta tags
const metas: Record<string, string>[] = [{
  name: 'description',
  content: 'Accedé a +1000 planos industriales con medidas exactas, proyectos de alto ticket y bonos exclusivos. Todo lo que necesitás para fabricar y vender desde tu taller de herrería.'
}, {
  name: 'robots',
  content: 'index, follow'
}, {
  property: 'og:title',
  content: 'Mega Pack Maestro Herrero | +1000 Planos Industriales'
}, {
  property: 'og:description',
  content: 'Fabricá proyectos que se venden con planos profesionales, medidas exactas y formación práctica. Acceso inmediato.'
}, {
  property: 'og:image',
  content: 'https://cdn.magicpatterns.com/uploads/87dYyEWwxvxDSawQQfbd23/WhatsApp_Image_2026-03-23_at_23.51.54.jpg'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:locale',
  content: 'es_AR'
}, {
  name: 'twitter:card',
  content: 'summary_large_image'
}, {
  name: 'twitter:title',
  content: 'Mega Pack Maestro Herrero | +1000 Planos Industriales'
}, {
  name: 'twitter:description',
  content: 'Fabricá proyectos que se venden con planos profesionales y medidas exactas.'
}];
metas.forEach(attrs => {
  const m = document.createElement('meta');
  Object.entries(attrs).forEach(([k, v]) => m.setAttribute(k, v));
  frag.appendChild(m);
});
// JSON-LD Structured Data
const ld = document.createElement('script');
ld.type = 'application/ld+json';
ld.textContent = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Mega Pack Maestro Herrero',
  description: '+1000 planos industriales con medidas exactas para fabricar y vender desde tu taller de herrería.',
  image: 'https://cdn.magicpatterns.com/uploads/87dYyEWwxvxDSawQQfbd23/WhatsApp_Image_2026-03-23_at_23.51.54.jpg',
  offers: {
    '@type': 'AggregateOffer',
    lowPrice: '19990',
    highPrice: '29990',
    priceCurrency: 'ARS',
    offerCount: 2,
    availability: 'https://schema.org/InStock'
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5',
    reviewCount: '5'
  }
});
frag.appendChild(ld);
// Single DOM write
document.head.appendChild(frag);
document.documentElement.lang = 'es';
document.title = 'Mega Pack Maestro Herrero | +1000 Planos Industriales para Tu Taller';
// === META PIXEL — deferred ===
let pixelLoaded = false;
function loadPixel() {
  if (pixelLoaded) return;
  pixelLoaded = true;
  const fbq: any = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [] as any[];
  (window as any).fbq = fbq;
  (window as any)._fbq = fbq;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  fbq('init', '1272637858178142');
  fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 3000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}